import { Head } from '@inertiajs/react'
import { useTranslation } from 'react-i18next'
import { BotIcon } from 'lucide-react'
import { ProjectsLayout } from '@/layouts/projects-layout'
import { FDEConversationList } from '@/components/fde/FDEConversationList'
import type { FDEConversation } from '@/types/fde'

interface Props {
  conversations: FDEConversation[]
}

export default function FDEIndex({ conversations }: Props) {
  const { t } = useTranslation('fde')

  return (
    <>
      <Head title={t('pageTitle')} />
      <div className="flex h-dvh overflow-hidden">
        <FDEConversationList
          conversations={conversations}
          activeConversationId={null}
        />
        <div className="flex flex-1 items-center justify-center">
          <div className="text-center">
            <BotIcon className="mx-auto h-12 w-12 text-muted-foreground/30 mb-4" />
            <h3 className="text-lg font-medium mb-1">{t('chat.emptyState')}</h3>
            <p className="text-sm text-muted-foreground max-w-sm">{t('chat.emptyStateDescription')}</p>
          </div>
        </div>
      </div>
    </>
  )
}

FDEIndex.layout = (page: React.ReactNode) => <ProjectsLayout>{page}</ProjectsLayout>
